export default {"src":"/_next/static/media/virtual_reality.e2b2d27e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};